import { CustomText } from '@4beefopag/4bee-fopag-core/dist/atoms';
import { Input, message, Tag } from 'antd';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { isValidEmail } from '../../../services/util/email';

export function opacity(color, percent) {
  const hexAppend = Math.floor((percent * 255) / 100)
    .toString(16)
    .toUpperCase();
  return color + hexAppend;
}

const TagInput = styled(Input)`
  font-size: 0.9em !important;
  max-width: 180px;
`;

const NewTag = styled(Tag)`
  &.ant-tag {
    border: 1px dashed;
    cursor: pointer;
  }
`;

const TagContainer = styled.div`
  //display: flex;

  & .ant-typography,
  & .ant-tag {
    font-size: 14px;
  }

  & input {
    min-width: 100px;
  }

  & .ant-tag {
    padding-top: 1px;
  }

  & .anticon.anticon-close,
  & .ant-typography {
    color: var(--primary, #00a89c) !important;
  }
`;

const CustomTag = styled(Tag)`
  &.ant-tag {
    margin-bottom: 5px;
    border: 1px solid var(--primary, #00a89c);
    background-color: ${() => opacity(getComputedStyle(document.body).getPropertyValue('--primary'), 15)};
  }
`;

function TagsEmail({ emails, disabled, onChange, customValidation }) {
  const parseEmails = (emailsParam) => {
    if (!emailsParam) {
      return [];
    }

    if (Array.isArray(emailsParam)) {
      return emailsParam;
    }

    return emailsParam.split(';');
  };

  const parsedEmails = parseEmails(emails);
  const [inputVisible, setInputVisible] = useState(false);
  const [emailDigitado, setEmailDigitado] = useState('');

  const inputRef = useRef(null);

  const isLongTag = (tag) => tag.length > 20;

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, [inputVisible]);

  const adicionarEmail = () => {
    setInputVisible(false);

    if (emailDigitado) {
      const emailCorrigido = emailDigitado.replace(/\s/gi, '');

      if (!isValidEmail(emailCorrigido)) {
        message.error(
          `O endereço de e-mail ${emailCorrigido} está inválido. Por favor, verifique se o formato está correto e tente novamente..`
        );
        return;
      }

      const valido = customValidation(emailCorrigido);
      if (valido) {
        const arrayFinal = [...parsedEmails];

        const emailsPontoVirgula = emailCorrigido.split(';');

        for (let i = 0; i < emailsPontoVirgula.length; i += 1) {
          if (emailsPontoVirgula[i] && arrayFinal.indexOf(emailsPontoVirgula[i]) === -1) {
            arrayFinal.push(emailsPontoVirgula[i]);
          }
        }

        setEmailDigitado('');

        if (onChange) {
          onChange(arrayFinal);
        }
      }
    }
  };

  const removeItem = (indexToRemove) => {
    const novosEmails = parsedEmails.filter((value, index) => index !== indexToRemove);
    onChange(novosEmails);
  };

  return (
    <TagContainer>
      {parsedEmails.map((email, index) => (
        <CustomTag
          // eslint-disable-next-line
          key={`${index}_${email}`}
          closable={!disabled}
          title={email}
          onClose={() => removeItem(index)}
        >
          <CustomText
            onDoubleClick={(e) => {
              if (index !== 0) {
                e.preventDefault();
              }
            }}
          >
            {isLongTag(email) ? `${email.slice(0, 20)}...` : email}
          </CustomText>
        </CustomTag>
      ))}
      {inputVisible && (
        <TagInput
          type="text"
          ref={inputRef}
          size="small"
          value={emailDigitado}
          onChange={(e) => setEmailDigitado(e.target.value)}
          onBlur={() => adicionarEmail()}
          onPressEnter={() => adicionarEmail()}
        />
      )}
      {!inputVisible && !disabled && <NewTag onClick={() => setInputVisible(true)}> Adicionar e-mail</NewTag>}
    </TagContainer>
  );
}

TagsEmail.propTypes = {
  emails: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  customValidation: PropTypes.func,
};

TagsEmail.defaultProps = {
  emails: '',
  onChange: () => {},
  disabled: false,
  customValidation: () => true,
};

export default TagsEmail;
